import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/common/Navbar";
import CustomDashBoard from "./page/CustomDashBoard";
import WarrentySubmitPage from "./page/WarrentySubmitPage";
import LandingPage from "./page/LandingPage";
import SmartTable from "./page/SmartTable";
import Forbidden from "./page/Forbidden";
import config from "./config";

function buildLoginUrl(apiOrigin) {
  const loginHint = new URLSearchParams(window.location.search).get("login_hint");
  const loginUrl = `${apiOrigin}/auth/login`;
  return loginHint ? `${loginUrl}?login_hint=${encodeURIComponent(loginHint)}` : loginUrl;
}

function App() {
  // Gates the whole app shell on a valid, authorized Entra ID session -
  // mirrors iai_iica's "/" route check, adapted for a SPA that has to ask
  // the backend (GET /auth/session) rather than checking a server-rendered
  // template's own state.
  const [authChecked, setAuthChecked] = useState(false);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const apiOrigin = new URL(config.API_BASE_URL, window.location.origin).origin;

    fetch(`${apiOrigin}/auth/session`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (!data.authenticated) {
          window.location.href = buildLoginUrl(apiOrigin);
          return;
        }
        if (!data.authorized && window.location.pathname !== "/forbidden") {
          window.location.href = "/forbidden";
          return;
        }
        setUserName(data.name || "");
        setAuthChecked(true);
      })
      .catch(() => {
        // Can't reach the backend to check - fail safe by attempting
        // sign-in rather than silently showing the app with no data access.
        window.location.href = buildLoginUrl(apiOrigin);
      });
  }, []);

  if (!authChecked) {
    return null;
  }

  return (
    <Navbar userName={userName}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/claim" element={<WarrentySubmitPage />} />
        <Route path="/reports" element={<CustomDashBoard />} />
        <Route path="/smarttable" element={<SmartTable />} />
        <Route path="/forbidden" element={<Forbidden />} />
      </Routes>
    </Navbar>
  );
}

export default App;